// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3q93B","sectionsWrapper":"style_sectionsWrapper__3i19q"};